import React, { Component } from "react";
import { mInfo, mReadyToPaint } from "@masonite/svg-icons";
import Media from "react-media";
import "./tooltip.scss";
import { Author } from "react-structured-data/dist/schemas";

export class Tooltip extends Component {
    state = {
        displayTooltip: false,
        tooltipLocation: null
    };
    wrapperRef = React.createRef();
    messageRef = React.createRef();

    componentDidMount = () => {
        const { showOnCursor } = this.props;
        if (showOnCursor) {
            this.updateTooltipLocation();
        }

        window.addEventListener("scroll", this.handleScroll);
    };

    componentWillUnmount = () => {
        window.removeEventListener("scroll", this.handleScroll);
    };

    handleScroll = event => {
        const { controlledDisplay, handleClick } = this.props;
        const { displayTooltip } = this.state;

        // when we scroll and we have a tooltip thats open, fire click to close it
        if (
            this.wrapperRef &&
            !this.wrapperRef.current.contains(event.target) &&
            (displayTooltip || controlledDisplay)
        ) {
            if (handleClick) {
                handleClick();
            } else {
                this.changeTooltipDisplay();
            }
        }

        return true;
    };

    changeTooltipDisplay = () => {
        this.setState({
            displayTooltip: !this.state.displayTooltip
        });
    };

    // find position of the wrapper and based on that set the tooltip location
    updateTooltipLocation = () => {
        const { showOnCursor = false } = this.props;
        if (
            showOnCursor &&
            this.wrapperRef &&
            this.wrapperRef.current &&
            this.messageRef &&
            this.messageRef.current
        ) {
            const boundingRect = this.wrapperRef.current.getBoundingClientRect();
            const messageBoundingRect = this.messageRef.current.getBoundingClientRect();
            if (boundingRect) {
                this.setState({
                    tooltipLocation: {
                        top: boundingRect.top - boundingRect.height * 2,
                        // make sure we don't show tooltip off screen
                        left:
                            messageBoundingRect.width + boundingRect.left >
                            window.innerWidth
                                ? window.innerWidth -
                                  messageBoundingRect.width -
                                  16
                                : boundingRect.left
                    }
                });
            }
        }
    };

    render() {
        const {
            message,
            showIcon = true,
            image,
            showOnCursor = false,
            children,
            handleClick,
            controlledDisplay,
            responsive,
            tooltipBgSize = null,
        } = this.props;

        const { tooltipLocation, displayTooltip } = this.state;

        const imageStyle = {
            backgroundImage: image ? `url(${image})` : "none",
            height: "208px",
            width: "208px",
            backgroundRepeat: "no-repeat",
            backgroundSize: tooltipBgSize
                ? tooltipBgSize
                : "100% 100%",
            backgroundPosition: tooltipBgSize === "contain"
                ? "center"
                : null,
            marginLeft: "auto",
            marginRight: "auto",
        };

        return (
            <Media queries={{ mobile: { maxWidth: 768 } }}>
                {({ mobile }) => (
                    <div
                        className={`tooltip-wrapper ${
                            displayTooltip || controlledDisplay
                                ? "display-tooltip"
                                : ""
                        }`}
                        onClick={
                            mobile // allow click on mobile only
                                ? handleClick
                                    ? handleClick
                                    : this.changeTooltipDisplay
                                : null
                        }
                        ref={this.wrapperRef}
                        {...(showOnCursor
                            ? { onMouseOver: this.updateTooltipLocation }
                            : {})}
                    >
                        {showIcon && (
                            <span
                                className="info-icon"
                                dangerouslySetInnerHTML={{
                                    __html: mInfo
                                }}
                            />
                        )}

                        {children}

                        <div
                            className={`tooltip-message-wrapper positioned-right${
                                showOnCursor ? " fixed" : ""
                            }${responsive ? " responsive" : ""}`}
                            ref={this.messageRef}
                            {...(showOnCursor && tooltipLocation
                                ? {
                                      style: {
                                          position: "fixed",
                                          width: "auto",
                                          ...tooltipLocation
                                      }
                                  }
                                : {})}
                        >
                            {image && image === "paintIcon" && (
                                <div
                                    style={{
                                        ...imageStyle,
                                        fill: "#99c221",
                                        backgroundColor: "#f3f3f3"
                                    }}
                                >
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: mReadyToPaint
                                        }}
                                    />
                                </div>
                            )}
                            {image && image !== "paintIcon" && (
                                <div style={imageStyle} />
                            )}
                            {message && <p>{message}</p>}
                        </div>
                    </div>
                )}
            </Media>
        );
    }
}
